export const LOGIN_REQUEST: '@user/LOGIN_REQUEST' = '@user/LOGIN_REQUEST';
export const LOGIN_SUCCESS: '@user/LOGIN_SUCCESS' = '@user/LOGIN_SUCCESS';
export const LOGIN_FAIL: '@user/LOGIN_FAIL' = '@user/LOGIN_FAIL';
export const PREVIOUS_SIGNUP_STEP: '@user/PREVIOUS_SIGNUP_STEP' =
  '@user/PREVIOUS_SIGNUP_STEP';
export const SET_SIGNUP_STEP: '@user/SET_SIGNUP_STEP' = '@user/SET_SIGNUP_STEP';
export const SUBMIT_SIGNUP_STEP: '@user/SUBMIT_SIGNUP_STEP' =
  '@user/SUBMIT_SIGNUP_STEP';
export const SET_USER_INFO: '@user/SET_USER_INFO' = '@user/SET_USER_INFO';
export const SET_TOKEN: '@user/SET_TOKEN' = '@user/SET_TOKEN';
export const SET_EMAIL: '@user/SET_EMAIL' = '@user/SET_EMAIL';
export const SUBMIT_SIGNUP_STEP_SUCCESS: '@user/SUBMIT_SIGNUP_STEP_SUCCESS' =
  '@user/SUBMIT_SIGNUP_STEP_SUCCESS';
export const PREVIOUS_RECOVERY_STEP: '@user/PREVIOUS_RECOVERY_STEP' =
  '@user/PREVIOUS_RECOVERY_STEP';
export const SUBMIT_SIGNUP_STEP_FAIL: '@user/SUBMIT_SIGNUP_STEP_FAIL' =
  '@user/SUBMIT_SIGNUP_STEP_FAIL';
export const SET_PIN_ID: '@user/SET_PIN_ID' = '@user/SET_PIN_ID';
export const SET_IS_USER_FOUND: '@user/SET_IS_USER_FOUND' =
  '@user/SET_IS_USER_FOUND';
export const SET_LOGIN: '@user/SET_LOGIN' = '@user/SET_LOGIN';
export const SET_ROLES: '@user/SET_ROLES' = '@user/SET_ROLES';
export const SET_NOTIFICATIONS: '@user/SET_NOTIFICATIONS' =
  '@user/SET_NOTIFICATIONS';
export const GET_NOTIFICATIONS: '@user/GET_NOTIFICATIONS' =
  '@user/GET_NOTIFICATIONS';
export const SET_NOTIFICATION_READ: '@user/SET_NOTIFICATION_READ' =
  '@user/SET_NOTIFICATION_READ';
export const SET_NOTIFICATION_READ_SUCCESS: '@user/SET_NOTIFICATION_READ_SUCCESS' =
  '@user/SET_NOTIFICATION_READ_SUCCESS';
export const SET_NOTIFICATION_READ_FAILURE: '@user/SET_NOTIFICATION_READ_FAILURE' =
  '@user/SET_NOTIFICATION_READ_FAILURE';
export const GET_PROFILE_SETTINGS_INFO: '@user/GET_PROFILE_SETTINGS_INFO' =
  '@user/GET_PROFILE_SETTINGS_INFO';
export const SET_PROFILE_SETTINGS_INFO: '@user/SET_PROFILE_SETTINGS_INFO' =
  '@user/SET_PROFILE_SETTINGS_INFO';
export const UPDATE_PROFILE_SETTINGS_INFO: '@user/UPDATE_PROFILE_SETTINGS_INFO' =
  '@user/UPDATE_PROFILE_SETTINGS_INFO';
export const UPDATE_PROFILE_SETTINGS_INFO_SUCCESS: '@user/UPDATE_PROFILE_SETTINGS_INFO_SUCCESS' =
  '@user/UPDATE_PROFILE_SETTINGS_INFO_SUCCESS';
export const UPDATE_PROFILE_SETTINGS_INFO_FAIL: '@user/UPDATE_PROFILE_SETTINGS_INFO_FAIL' =
  '@user/UPDATE_PROFILE_SETTINGS_INFO_FAIL';

export const GET_USER_INFO: '@user/GET_USER_INFO' = '@user/GET_USER_INFO';
export const GET_USER_INFO_SUCCESS: '@user/GET_USER_INFO_SUCCESS' =
  '@user/GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAIL: '@user/GET_USER_INFO_FAIL' =
  '@user/GET_USER_INFO_FAIL';

export const SET_IDENTITY_IMAGES: '@user/SET_IDENTITY_IMAGES' =
  '@user/SET_IDENTITY_IMAGES';

export const RESEND_EMAIL: '@user/RESEND_EMAIL' = '@user/RESEND_EMAIL';
